var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0105 12.4867C14.722 9.98968 17.4083 7.51674 20.1418 5C14.6705 5 9.27386 5 3.80756 5C6.56174 7.51365 9.26884 9.98475 12.0105 12.4867ZM20.1431 16C18.2369 14.2227 16.3784 12.4898 14.5098 10.747C14.3887 10.8531 14.2939 10.9326 14.2035 11.0159C13.5627 11.606 12.9193 12.1931 12.2854 12.7907C12.0845 12.98 11.9238 12.9899 11.7312 12.7845C11.5617 12.6039 11.3677 12.4454 11.1838 12.2782C10.6258 11.7713 10.0672 11.265 9.49229 10.7433C7.61809 12.4972 5.769 14.2282 3.87723 15.9994C9.3178 16 14.6937 16 20.1431 16ZM20.4456 15.7293C20.4456 12.2153 20.4456 8.76616 20.4456 5.27196C18.545 7.02153 16.6815 8.73718 14.8036 10.4664C16.6884 12.2246 18.5482 13.9594 20.4456 15.7293ZM3.55273 15.7496C5.46333 13.9612 7.32497 12.219 9.19666 10.467C7.31054 8.74581 5.4558 7.05298 3.55273 5.31636C3.55273 8.81735 3.55273 12.2412 3.55273 15.7496Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0095 12.4867C9.26792 9.98475 6.56082 7.51365 3.80664 5C9.27294 5 14.6696 5 20.1409 5C17.4074 7.51674 14.7217 9.98968 12.0095 12.4867Z",
    fill: "#DAA520"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1434 15.9983C14.6941 15.9983 9.31814 15.9983 3.87695 15.9983C5.76935 14.2271 7.61844 12.4961 9.492 10.7422C10.0669 11.2639 10.6256 11.7702 11.1835 12.2771C11.3675 12.4443 11.5614 12.6034 11.7309 12.7835C11.9236 12.9888 12.0849 12.9783 12.2851 12.7896C12.9184 12.192 13.5624 11.6049 14.2032 11.0148C14.2936 10.9315 14.3884 10.852 14.5095 10.7459C16.3787 12.4874 18.2372 14.2204 20.1434 15.9983Z",
    fill: "#DAA520"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4448 15.7282C18.548 13.9589 16.6876 12.2241 14.8027 10.4659C16.6807 8.7367 18.5442 7.02105 20.4448 5.27148C20.4448 8.76445 20.4448 12.2136 20.4448 15.7282Z",
    fill: "#DAA520"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55273 15.7497C3.55273 12.2413 3.55273 8.81739 3.55273 5.31641C5.4558 7.05364 7.31054 8.74585 9.19666 10.467C7.32497 12.2191 5.46333 13.9612 3.55273 15.7497Z",
    fill: "#DAA520"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeGold);
export default __webpack_public_path__ + "static/media/envelope-gold.157ad71ab46567a963e9fb418eaf6f96.svg";
export { ForwardRef as ReactComponent };